import { render, staticRenderFns } from "./London.vue?vue&type=template&id=629cb163&"
import script from "./London.vue?vue&type=script&lang=js&"
export * from "./London.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports